import { FunctionComponent, ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

type ManagementToolbarFieldProps = {
  label: string;
  labelId: string;
  /** Associates the visible label with a control id (e.g. Mobiscroll input). */
  htmlFor?: string;
  children: ReactNode;
};

/**
 * Shared filter-bar field: one external label style above every control
 * (selects, toggles, period strip) so the toolbar reads as one vocabulary.
 */
export const ManagementToolbarField: FunctionComponent<ManagementToolbarFieldProps> = ({
  label,
  labelId,
  htmlFor,
  children
}) => (
  <Stack spacing={0.75} sx={{ width: "100%", minWidth: 0 }}>
    <Typography
      id={labelId}
      component="label"
      htmlFor={htmlFor}
      variant="body2"
      color="text.secondary"
      sx={{ fontWeight: 600, lineHeight: 1.2 }}
    >
      {label}
    </Typography>
    {children}
  </Stack>
);
